<template>
  <div class="modal_dim" :class="{'on': isShowAlert}">
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.ALERT">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl bg"></div>
              <div class="txt_con">
                <p v-html="data.message"></p>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn" @click="fnConfirm()">닫힘</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.CONFIRM">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">{{ data.title }}</div>
              <div class="txt_con">
                <p>{{ data.message }}</p>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="fnClose()">취소</button>
              <button class="btn" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.ALLOWAUTH">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">접근 권한 안내</div>
              <div class="txt_con">
                <p class="modal_txt__small" style="padding: 0">셔틀아이 서비스 이용을 위해 다음 권한들을 사용합니다.</p>
              </div>
              <div class="txt_con__type04">
                <p class="txt_con__type04__ttl">필수 접근 권한</p>
                <p class="txt_con__type04__inner"><i class="i_location"></i>위치</p>
                <p class="txt_con__type04__txt">버스 운행 정류장의 위치를 확인하기 위해 필요한 권한입니다.</p>
                <p class="txt_con__type04__inner"><i class="i_call_yellow"></i>전화</p>
                <p class="txt_con__type04__txt">버스 동승보호자 또는 기사님께 전화를 걸기 위해 필요한 권한입니다.</p>
              </div>
              <div class="line"></div>
              <p class="txt_con__type04__ttl" style="margin-top: 2rem">선택 접근 권한</p>
              <p class="txt_con__type04__inner"><i class="i_camera"></i>사진</p>
              <p class="txt_con__type04__txt" style="margin-bottom: 0;">자녀 등록 시 프로필 이미지를 등록할 경우 필요한 권한입니다.</p>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.UPDATE">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">업데이트</div>
              <div class="txt_con">
                <p>최신 업데이트 버전이 있습니다.<br>업데이트 하시겠습니까?</p>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="fnClose()">나중에</button>
              <button class="btn" @click="fnConfirm()">업데이트</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.FINDID">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">아이디 찾기</div>
              <div class="txt_con">
                <p>회원님의 아이디는<br>
                  <span v-html="data.message"></span><br>
                  입니다.
                </p>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
<!--              <button class="btn bo" @click="$router.replace('/account/findPWD')">비밀번호 찾기</button>-->
              <button class="btn bo" @click="fnReplaceRoute('/app/account/findPWD')">비밀번호 찾기</button>
<!--              <button class="btn" @click="$router.replace('/account/login')">로그인</button>-->
              <button class="btn" @click="fnReplaceRoute('/app/account/login')">로그인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.MARKETING">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">마케팅 정보 앱 푸시 동의 안내</div>
              <div class="txt_con__type02">
                <p>전송자: 기업누리</p>
                <p>수신 동의 일시: <span>{{ $moment(new Date()).format('YYYY년 MM월 DD일 HH시 mm분')}}</span></p>
                <p>처리내용: 수신 <span v-html="data.message"></span> 처리 완료</p>
              </div>
              <div class="line"></div>
              <p class="modal_txt__small">본 광고성(PUSH)는 환경 설정에서 변경 가능합니다.</p>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.LOGOUT">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">로그아웃</div>
              <div class="txt_con">
                <p>로그아웃 하시겠습니까?</p>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="fnClose()">취소</button>
              <button class="btn" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.WITHDRAW">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl">회원 탈퇴</div>
              <div class="txt_con__type03">
                <p>회원을 탈퇴하시겠습니까?</p>
              </div>
              <div class="line"></div>
              <p class="modal_txt__small red">탈퇴시 해당 정보로 재가입이 불가능합니다.</p>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="fnClose()">취소</button>
              <button class="btn" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_wrap" v-if="type === $ConstCode.CONFIRM_TYPE.DELETE">
      <div class="modal_inner center">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt">
              <div class="txt_ttl bg"></div>
              <div class="txt_con">
                <p>삭제 하시겠습니까?</p>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="fnClose()">취소</button>
              <button class="btn" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-alert-container',
  props: {
    type: {
      type: Number
    },
    data: {
      type: Object
    },
    callBack: {
      type: Function
    }
    // modalAlertName: {
    //   type: [Object, String],
    //   description: 'modal component 명'
    // },
    // zIndex: {
    //   type: Number,
    //   default: 2100
    // },
    // data: {
    //   type: Object
    // },
    // modalAlertTitle: {
    //   type: [String],
    //   description: 'modal 타이틀',
    //   default: () => ''
    // },
    // callBack: {
    //   type: Function,
    //   description: 'callBack function'
    // },
    // confirmLabel: {
    //   type: [String],
    //   default: '확인'
    // },
    // cancelLabel: {
    //   type: [String],
    //   default: '취소'
    // }
  },
  data: function () {
    return {
      query: this.$route.path,
      userData: {},
      isBack: false,
      selectItem: this.data.list === undefined ? null : this.data.list[0],
    }
  },
  mounted() {
    const route = this.$_.clone(this.$route)
    if (!route.hash.match('#')) {
      this.isBack = true
      route.hash = "#"
      this.$router.push(route)
    }
    setTimeout(() => {
      this.$store.commit('layout/setIsShowModalAlert', {isShowAlert: true})
    }, 10)
  },
  computed: {
    isShowAlert: function () {
      return this.$store.getters['layout/getIsShowModalAlert']
    }
  },
  watch: {
    '$route.hash': function (val) {
      if (!val) this.$emit('close')
    }
  },
  methods: {
    fnClose: function (go = -1) {
      if (this.isBack) this.$router.go(go)
      this.$emit('close')
    },
    fnConfirm: function (returnData, go = -1) {
      if (this.callBack !== undefined && this.callBack !== null) {
        if (returnData !== undefined && returnData !== null) {
          this.callBack(returnData)
        } else {
          this.callBack()
        }
        if (this.isBack) this.$router.go(go)
      } else {
        if (this.isBack) this.$router.go(go)
      }
      this.$emit('close')
    },
    fnSelect: function (go = -1) {
      if (this.callBack !== undefined && this.callBack !== null) {
        this.callBack(this.selectItem)
        if (this.isBack) this.$router.go(go)
      } else {
        if (this.isBack) this.$router.go(go)
      }
    },
    fnMoveRoute: function (path = '/', query = {}) {
      this.$emit('close')
      setTimeout(() => {
        this.$router.push({
          path: path,
          query: query
        })
      }, 300)
    },
    fnReplaceRoute: function (path = '/', query = {}) {
      this.$emit('close')
      setTimeout(() => {
        this.$router.replace({
          path: path,
          query: query
        })
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
